import type { FabricEditor } from 'modules/fabric-editor';
import { selectActiveBoard } from 'modules/manager/store';
import { useEffect, useRef } from 'react';
import { useAppSelector } from 'store/hooks';

export function useRestoreBoard(editor: FabricEditor | null): void {
  const board = useAppSelector(selectActiveBoard);
  const restoredFor = useRef<number | null>(null);

  useEffect(() => {
    if (!editor || !board) return;
    if (restoredFor.current === board.id) return;
    restoredFor.current = board.id;

    const payload = { version: board.version, objects: board.objects ?? [] };
    editor.canvas.loadFromJSON(payload, () => {
      editor.canvas.renderAll();
      // Emit canvas:loaded first so plugins that react by adding their own
      // objects (e.g. grid rebuild) finish their add cycle before we clear
      // dirty state — otherwise their object:added events re-mark dirty.
      editor.emit('canvas:loaded', { source: 'restore' });
      editor.history?.clear();
      editor.dirty?.markClean();
    });
  }, [editor, board]);
}
